import { apiJson } from './api';
import type { Law, Article } from '@/types';

export async function getLaws(): Promise<Law[]> {
  return apiJson<Law[]>('/api/laws');
}

export async function getLawById(lawId: string): Promise<Law> {
  return apiJson<Law>(`/api/laws/${lawId}`);
}

export async function getArticlesByLawId(lawId: string): Promise<Article[]> {
  return apiJson<Article[]>(`/api/laws/${lawId}/articles`);
}

export async function getArticleById(lawId: string, articleId: string): Promise<Article | null> {
  const articles = await getArticlesByLawId(lawId);
  return articles.find((a) => a.id === articleId) ?? null;
}
